import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import Button from 'reactstrap/lib/Button';
// Models
import { InventoryModel } from 'client/data/models/inventory';
// Utils
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
// Components
import { UpgradeDescription } from 'site-modules/inventory/components/features-and-specs/upgrade-description';

import './upgrade-item.scss';

export function UpgradeItemUI({
  vin,
  name = '',
  price = 0,
  id = 0,
  packageValue = 0,
  isDescriptionEligible = false,
  optionDescription = null,
}) {
  const [isExpandedDescription, setIsExpandedDescription] = useState(false);
  const description = get(optionDescription, `${id}.description`);
  const isDescriptionEnabled = isDescriptionEligible && !!description;

  const handleExpandClick = useCallback(() => {
    setIsExpandedDescription(!isExpandedDescription);
  }, [isExpandedDescription]);

  return (
    <li
      className={classnames('upgrade-item py-1 d-flex', {
        'justify-content-between': !isDescriptionEnabled,
        'flex-column': isDescriptionEnabled,
      })}
    >
      {isDescriptionEnabled ? (
        <>
          <Button
            onClick={handleExpandClick}
            className="upgrade-item-name-btn d-flex justify-content-between border-0 text-transform-none fw-medium size-16 text-gray-darker text-start p-0"
          >
            <div className="fw-medium">{name}</div>
            {packageValue > 0 && <div className="fw-medium ps-0_5">{formatPriceString(price)}</div>}
          </Button>
          <UpgradeDescription vin={vin} optionId={id} isOpen={isExpandedDescription} />
          <Button
            onClick={handleExpandClick}
            color="link"
            className="description-toggle-btn d-flex align-items-center text-transform-none medium p-0 fw-normal mt-0_5 text-primary-darker"
          >
            {isExpandedDescription ? 'View less' : 'View more'}
            <i
              className={classnames('ms-0_5 size-10', {
                'icon-arrow-down4': !isExpandedDescription,
                'icon-arrow-up4': isExpandedDescription,
              })}
              aria-hidden
            />
          </Button>
        </>
      ) : (
        <>
          <div className="fw-medium ps-0">{name}</div>
          {packageValue > 0 && <div className="fw-medium p-0">{formatPriceString(price)}</div>}
        </>
      )}
    </li>
  );
}

UpgradeItemUI.propTypes = {
  vin: PropTypes.string.isRequired,
  name: PropTypes.string,
  price: PropTypes.number,
  id: PropTypes.number,
  packageValue: PropTypes.number,
  isDescriptionEligible: PropTypes.bool,
  optionDescription: PropTypes.objectOf(
    PropTypes.shape({
      description: PropTypes.string,
    })
  ),
};

export const stateToPropsConfig = {
  optionDescription: bindToPath(({ vin }) => `optionDescription["${vin}"]`, InventoryModel),
};

export const UpgradeItem = connectToModel(UpgradeItemUI, stateToPropsConfig);
